import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "calendar" }
const _hoisted_2 = { class: "calendar__wrapper" }
const _hoisted_3 = { class: "calendar__button-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "arrow arrow--left" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "calendar__day-header" }
const _hoisted_9 = { class: "calendar__day--grey" }
const _hoisted_10 = { class: "calendar__slots" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "calendar__button-wrapper" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "arrow arrow--right" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["calendar__arrow-button", _ctx.allowToDecreaseClass]),
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.decrease && _ctx.decrease(...args)), ["prevent"]))
        }, _hoisted_5, 2)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: `label:${index + 1}of${_ctx.daysLength}`,
              class: _normalizeClass(["calendar__day", { 'calendar__day--compressed': _ctx.compressedView }])
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, _toDisplayString(day.dayMonthLabel), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(day.dayNameLabel), 1)
              ])
            ], 2)), [
              [_vShow, (index >= _ctx.controler) && (index < _ctx.controler + _ctx.columns)]
            ])
          }), 128))
        ]),
        _createElementVNode("div", {
          ref: "scrollWrapper",
          class: _normalizeClass(["calendar__slots-wrapper", { 'calendar__slots-wrapper--compressed': _ctx.compressedView }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: `column:${index + 1}of${_ctx.daysLength}`
            }, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.slots, (slot) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: slot.date,
                    class: _normalizeClass(["calendar__slot", _ctx.slotClasses(slot)]),
                    onClick: _withModifiers(($event: any) => (_ctx.onSlotChange(slot)), ["prevent"])
                  }, _toDisplayString(slot.date), 11, _hoisted_11))
                }), 128))
              ])
            ], 512)), [
              [_vShow, (index >= _ctx.controler) && (index < _ctx.controler + _ctx.columns)]
            ])
          }), 128))
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          class: _normalizeClass(["calendar__arrow-button", _ctx.allowToIncreaseClass]),
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.increase && _ctx.increase(...args)), ["prevent"]))
        }, _hoisted_14, 2)
      ])
    ])
  ]))
}